import { render, staticRenderFns } from "./BuyFinishList.vue?vue&type=template&id=60edb00e&scoped=true"
import script from "./BuyFinishList.vue?vue&type=script&lang=js"
export * from "./BuyFinishList.vue?vue&type=script&lang=js"
import style0 from "./BuyFinishList.vue?vue&type=style&index=0&id=60edb00e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60edb00e",
  null
  
)

export default component.exports